// extracted by mini-css-extract-plugin
module.exports = {"container":"Product_container__1sltt"};